import { memoSanitize } from '@axa-asia/emma-safely-set-inner-html';
import React, { Component } from 'react';
import { connect } from 'react-redux';

import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from '@axa-asia/emma-stylesheet/lib/components/Modal';
import { getEmmaContactCallModelAttributes } from '../../../selectors/uiSelectors';

import { closeContactCallModel } from '../../../actions/uiActions';
import './styles.scss';
import { t } from '../../../locales';
import { select } from '../../../stores';
import { getValidToken } from '../../../utils';
import { getToken } from '../../../selectors/authSelectors';
import {
  getGaPagePath,
  handleGaError,
} from '../../../utils/generalGaEventAnalytics';
import { trackBenefitCoverageCallProvider } from '../../../utils/firebaseAnalyticsEvents';
import { EmmaIcon, EmmaSpace } from '@axa-asia/emma-stylesheet';
import classNames from 'classnames';

type ContactCallModalBodyItem = {
  label: string;
  value: string;
  email: string;
  notes: string;
  link: string;
};

interface EmmaCallSupportModelProps {
  dialog: {
    visible: boolean;
    modalType?: 'lockedModal';
    title?: string;
    subTitle: string;
    bodyContent?: ContactCallModalBodyItem[];
    reservationBtnText: string;
    okButtonText?: string;
    okAction?: any;
    onCloseCallBack?: () => void;
    closeAction?: any;
  };
  closeDialog: any;
  okDialog: any;
  onCloseCallBack?: any;
}

const isNormalWebsiteUrl = (url: string) => {
  return url.startsWith('https://') || url.startsWith('http://');
};

// eslint-disable-next-line @typescript-eslint/no-empty-interface
interface EmmaCallSupportModelState {}

class EmmaCallSpupportModel extends Component<
  EmmaCallSupportModelProps,
  EmmaCallSupportModelState
> {
  constructor(props: EmmaCallSupportModelProps) {
    super(props);
  }

  onClickToGatc(itemLabel: any, phoneNum: any) {
    const tcWindow: any = window;
    const token = select(getToken);
    const aToken = getValidToken(token);
    const phoneNumber = `+${phoneNum.replace('(', '').replace(')', ' ')}`;
    // ga#2
    try {
      trackBenefitCoverageCallProvider('Life', itemLabel, phoneNumber);
      tcWindow.dataLayer.push({
        event: 'coveragePhoneCall',
        product: 'Life',
        // "providerName": itemLabel, // PII not sending
        // "providerPhone": phoneNumber, // PII not sending
        screenName: getGaPagePath(),
        userId: aToken,
      });

      // HKEMMA-100917 - GA3 Decommission - Remove GA3
      // if (!isApp()) {
      //   tcWindow.tC.event.coveragePhoneCall(this, {
      //     product: 'Life',
      //     // "providerName": itemLabel, // PII not sending
      //     // "providerPhone": phoneNumber, // PII not sending
      //     screenName: getGaPagePath(),
      //     AXAID: aToken,
      //   });
      // }
    } catch (e) {
      handleGaError(e);
    }
  }

  render() {
    const { dialog, closeDialog, okDialog } = this.props;

    let header, modalClass, okButton, closeButton, otherButton, subHeader;
    if (dialog) {
      const okButtonText = dialog.okButtonText ? dialog.okButtonText : 'OK';

      if (dialog.modalType === 'lockedModal') {
        header = (
          <div>
            <div
              className="emma-contact-call-modal-locked__text"
              dangerouslySetInnerHTML={{ __html: memoSanitize(dialog.title) }}
            ></div>
          </div>
        );
        subHeader = (
          <div className="emma-contact-call-modal__sub_title">
            {dialog.subTitle}
          </div>
        );
        modalClass = 'emma-contact-call-modal emma-contact-call-modal-locked';
        if (dialog.okAction) {
          okButton = (
            <button
              className="emma-stylesheet-primary-default-button"
              onClick={() => {
                okDialog(dialog.okAction);
                dialog.onCloseCallBack && dialog.onCloseCallBack();
              }}
              data-enable-ga
              data-ga-type="button"
            >
              {okButtonText}
            </button>
          );
        }
        if (dialog.closeAction) {
          closeButton = (
            <button
              className="emma-contact-call-modal-locked__close"
              onClick={() => closeDialog(dialog.closeAction)}
              data-enable-ga
              data-ga-type="button"
            >
              {' '}
              {t('CLOSE')}{' '}
            </button>
          );
        }
      } else {
        header = <div>{dialog.title}</div>;
        subHeader = (
          <div className="emma-contact-call-modal__sub_title">
            {dialog.subTitle}
          </div>
        );
        modalClass = 'emma-contact-call-modal';
        okButton = (
          <button
            className="emma-stylesheet-primary-default-button"
            onClick={() => okDialog(dialog.okAction)}
            data-enable-ga
            data-ga-type="button"
          >
            {okButtonText}
          </button>
        );
      }
    }

    return (
      <div>
        {dialog && (
          <Modal show={dialog.visible}>
            <ModalHeader>
              <div>
                {header}
                {subHeader}
              </div>
            </ModalHeader>
            <ModalBody>
              <div className="emma-contact-call-modal__body">
                {dialog.bodyContent &&
                  dialog.bodyContent.map((item: any, index: number) => {
                    const isTargetNormalWebsite = isNormalWebsiteUrl(
                      item.link ?? '',
                    );
                    return (
                      <div
                        key={index}
                        className="emma-contact-call-modal__content"
                      >
                        <div className="contact-call-label">{item.label}</div>
                        {item.value.includes('TBC') ? (
                          <div className="contact-call-value">{item.value}</div>
                        ) : (
                          <div>
                            {item.email !== '' && (
                              <div className="mb4">
                                <a
                                  href={`mailto:${item.email}`}
                                  className="contact-call-email"
                                >
                                  {item.email}
                                </a>
                              </div>
                            )}
                            <div
                              className={classNames(
                                EmmaSpace.mb4,
                                EmmaSpace.mt4,
                              )}
                            >
                              <a
                                className="contact-call-value"
                                href={`tel: +${item.value.replace(
                                  /\(|\)/g,
                                  '',
                                )}`}
                                onClick={() => {
                                  this.onClickToGatc(
                                    item.label,
                                    item.value.replace(/\s+/g, ''),
                                  );
                                }}
                                data-enable-ga
                                data-ga-type="link"
                              >
                                <EmmaIcon
                                  iconKey={'functional/phone'}
                                  size={16}
                                  className={EmmaSpace.mr4}
                                />
                                {`${item.value}`}
                              </a>
                            </div>
                            {item?.hotlineAndWhatsapp && (
                              <div
                                className={classNames(
                                  EmmaSpace.mb4,
                                  EmmaSpace.mt4,
                                )}
                              >
                                <a
                                  className="contact-call-value"
                                  href={`tel: +${item.hotlineAndWhatsapp.replace(
                                    /\(|\)/g,
                                    '',
                                  )}`}
                                  onClick={() => {
                                    this.onClickToGatc(
                                      item.label,
                                      item.hotlineAndWhatsapp.replace(
                                        /\s+/g,
                                        '',
                                      ),
                                    );
                                  }}
                                  data-enable-ga
                                  data-ga-type="link"
                                >
                                  <EmmaIcon
                                    iconKey="functional/whatsapp-line"
                                    size={16}
                                    className={EmmaSpace.mr4}
                                  />
                                  {`${item.hotlineAndWhatsapp}`}
                                </a>
                              </div>
                            )}
                            {item.notes !== '' && (
                              <div className="contact-call-notes">
                                {item.notes}
                              </div>
                            )}
                            {item.link !== '' && (
                              <div className="emma-contact-call-modal__ok-wrap">
                                <a
                                  href={item.link}
                                  target={
                                    isTargetNormalWebsite ? '_blank' : undefined
                                  }
                                  rel={'noreferrer'}
                                >
                                  <button
                                    className="emma-contact-call-modal__ok"
                                    data-enable-ga
                                    data-ga-type="button"
                                  >
                                    {t('BOOK_NOW')}
                                  </button>
                                </a>
                              </div>
                            )}
                          </div>
                        )}
                      </div>
                    );
                  })}
              </div>
            </ModalBody>
            <ModalFooter>
              <div className="emma-contact-call-modal__btn-wrapper">
                {okButton}
                {otherButton}
              </div>
            </ModalFooter>
          </Modal>
        )}
      </div>
    );
  }

  static mapStateToProps(state: any) {
    return {
      dialog: Object.assign({}, getEmmaContactCallModelAttributes(state)),
    };
  }

  static mapDispatchToProps(dispatch: any) {
    return {
      closeDialog: (payload: any) => dispatch(closeContactCallModel(payload)),
      okDialog: (payload: any) => dispatch(closeContactCallModel(payload)),
    };
  }
}

export default connect(
  EmmaCallSpupportModel.mapStateToProps,
  EmmaCallSpupportModel.mapDispatchToProps,
)(EmmaCallSpupportModel);
